import styled from 'styled-components';
import { ColumnFlexContainer } from '../../../stories/atoms/containerV2/ContainerV2';

export const StyledContainer = styled(ColumnFlexContainer)<{ isMobile: boolean }>`
  ${({ isMobile, theme }) =>
    !isMobile &&
    `
    & > div {
      border: 1px solid
        ${theme.palette.mode === 'dark' ? theme.color.borderGrayDark : theme.color.borderGray};
      border-radius: ${theme.spacing(2)};
    }
  `};

  ${({ isMobile, theme }) =>
    isMobile &&
    `
    & > div:not(:last-child) {
      border-bottom: 1px solid
        ${theme.palette.mode === 'dark' ? theme.color.borderGrayDark : theme.color.borderGray};
    }
  `};
`;
